<div class="modal-content">
  <div class="modal-header mb-n1">
    <span aria-hidden="true"><mdb-icon id="closeInterstitialPopupIcon" tabindex="0" class="modal-close-icon" aria-label="Close" (click)="closeModal()" fas icon="times"></mdb-icon></span>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-12 text-center">
        <h2 class="mb-4">{{ title }}</h2>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 text-center mb-4" [innerHTML]="content | safeHtml">
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-center mb-3">
        <a id="interstitialPopupContinueLink" class="btn primary-btn waves-light uppercase" mdbBtn mdbWavesEffect (click)="followLink()">Continue</a>
      </div>
    </div>
  </div>
</div>
